/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWorkPackageDependencyRequest } from '../../models/create-work-package-dependency-request';
import { WorkPackageDependencyDto } from '../../models/work-package-dependency-dto';

export interface CreateWorkPackageDependency$Params {
      body: CreateWorkPackageDependencyRequest
}

export function createWorkPackageDependency(http: HttpClient, rootUrl: string, params: CreateWorkPackageDependency$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageDependencyDto>> {
  const rb = new RequestBuilder(rootUrl, createWorkPackageDependency.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageDependencyDto>;
    })
  );
}

createWorkPackageDependency.PATH = '/v0/workPackageDependencies';
